const Toasts = () => {
    const toast = document.querySelector('.infoToast');

    if (toast) {
        const toastId = toast.getAttribute('data-toast-id');
        const displayAgainTime = toast.getAttribute('data-time');
        const autoClose = toast.getAttribute('data-autoclose') === '1'; // Convert to boolean
        const closeTime = toast.getAttribute('data-close-time'); // Time in seconds

        const lastToastTime = localStorage.getItem(`lastToastTime_${toastId}`);
        const now = new Date().getTime();
        const toastDisplayHours = displayAgainTime ? parseInt(displayAgainTime) : 4;


        if (lastToastTime && (now - lastToastTime < toastDisplayHours * 60 * 60 * 1000)) {
            return;
        }


        setTimeout(() => {
            toast.classList.add('show');
        }, 1000);

        const close = toast.querySelector('.infoToastClose');


        if (autoClose && closeTime) {
            setTimeout(() => {
                toast.classList.add('close');
                localStorage.setItem(`lastToastTime_${toastId}`, now);
            }, closeTime * 1000)
        }


        close.addEventListener('click', () => {
            toast.classList.add('close');
            localStorage.setItem(`lastToastTime_${toastId}`, now);
        });
    }
};

export default Toasts;
